module.exports = __webpack_public_path__ + "static/K1.34354a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/K1.jpg
// module id = 460
// module chunks = 37721738025407